import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { correctionRecordDetail } from '../request';
import { typeMapObj } from '../correctionApplication/util.js';
import { REDUCE, REPLACE, ADD } from '../correctionApplication/util';
let that = null;
export default {
  props: {
    detailVisible: {
      type: Boolean,
      default: false
    },
    correctionItem: {
      type: Object,
      default: () => {}
    },
    policyPurpose: {
      type: String,
      default: 'other'
    }
  },
  watch: {
    detailVisible: {
      handler(val) {
        if (val) {
          var _this$correctionItem$;
          this.pagination = {
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0,
            pageSize: 10,
            // 每页条数
            current: 1,
            showTotal: total => {
              return `${that.$t('共') + total + that.$t('条')}`;
            }
          };
          this.effectiveAt = (_this$correctionItem$ = this.correctionItem.correctEffectiveAt) === null || _this$correctionItem$ === void 0 ? void 0 : _this$correctionItem$.replace(' 00:00:00', '');
          this.getList();
        }
      },
      immediate: true
    },
    policyPurpose: {
      handler(val) {
        if (val === 'groupInsurance') {
          this.columns = this.columns.filter(item => item.key !== 'premium');
          this.columns.splice(1, 0, {
            slots: {
              title: '工种类别'
            },
            dataIndex: 'occupationType',
            key: 'occupationType',
            width: 100,
            align: 'center'
          }, {
            slots: {
              title: '保险方案'
            },
            dataIndex: 'insurancePlanName',
            key: 'insurancePlanName',
            width: 150,
            align: 'center'
          }, {
            slots: {
              title: '劳动合同单位（共同被保险人）'
            },
            dataIndex: 'contractCompany',
            key: 'contractCompany',
            width: 180,
            align: 'center'
          }, {
            slots: {
              title: '实际工作单位（派遣单位）'
            },
            dataIndex: 'dispatchCompany',
            key: 'dispatchCompany',
            width: 180,
            align: 'center'
          });
        }
      },
      immediate: true
    }
  },
  created() {
    that = this;
  },
  data() {
    const that = this;
    return {
      effectiveAt: '',
      dataSource: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '工种'
        },
        dataIndex: 'occupation',
        key: 'occupation',
        width: 100,
        align: 'center'
      }, {
        slots: {
          title: '类型'
        },
        dataIndex: 'recordType',
        key: 'recordType',
        align: 'center',
        width: 110,
        customRender: text => {
          return that.$t(typeMapObj[text]);
        }
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: 'name',
        width: 100,
        align: 'center'
      }, {
        slots: {
          title: '证件类型'
        },
        dataIndex: 'identificationType',
        key: 'identificationType',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '证件号码'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        width: 200,
        align: 'center'
      }, {
        slots: {
          title: '生效日期'
        },
        dataIndex: 'correctEffectiveAt',
        key: 'correctEffectiveAt',
        align: 'center',
        width: 120
      }, {
        slots: {
          title: '保费变化量'
        },
        dataIndex: 'premium',
        key: 'premium',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '备注'
        },
        dataIndex: 'remark',
        key: 'remark',
        align: 'center',
        width: 150,
        ellipsis: true
      }],
      detailInfo: {}
    };
  },
  methods: {
    getList() {
      correctionRecordDetail({
        correctRecordId: this.correctionItem.id
      }).then(res => {
        this.dataSource = res.personnelList.map(item => {
          item.correctEffectiveAt = item.correctEffectiveAt.replace(' 00:00:00', '');
          return item;
        });
        this.pagination.total = Number(res.total);
        this.detailInfo = res.correctDetail;
        let safeguard = res.correctDetail.safeguard;
        this.detailInfo.replaceItems = [];
        this.detailInfo.incrementItems = [];
        this.detailInfo.reduceItems = [];
        safeguard.forEach(item => {
          if (item.type === REPLACE) {
            this.detailInfo.replaceItems.push(item);
          } else if (item.type === ADD) {
            this.detailInfo.incrementItems.push(item);
          } else if (item.type === REDUCE) {
            this.detailInfo.reduceItems.push(item);
          }
        });
        this.detailInfo.replaceItemsLength = this.detailInfo.replaceItems.length;
        this.detailInfo.incrementItemsLength = this.detailInfo.incrementItems.length;
        this.detailInfo.reduceItemsLength = this.detailInfo.reduceItems.length;
      });
    },
    handleStandardTableChange(pagination) {
      this.pagination = pagination;
      this.getList();
    }
  }
};